module.exports = __webpack_public_path__ + "static/media/mode-532.bab0a684.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-532.svg
// module id = 1068
// module chunks = 2